import React from 'react'
import './CarrierApptCardSS.css'
import { getFormattedDate } from '../../../../../../../../../Utils/DateUtils';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import CustomButtonSS from '../../../../../../../Common/CustomButton/CustomButtonSS';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';

function CarrierApptCardSS(props) {
    const { rowData } = props;
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userObj = useSelector(getUserSelector);
    const {  userType, userAccountDetails } = userObj;

    const getColor = () => {
        if (rowData[0]?.ApptScheStatus.toLowerCase() === 'rescheduled') {
            return 'aapt-card-rescheduled'
        }
        else if (rowData[0]?.ApptScheStatus.toLowerCase() === 'in progress') {
            return 'aapt-card-inprogress'
        }
        
        else if(rowData[0]?.ApptScheStatus.toLowerCase() === 'completed')
            {
                return 'aapt-card-completed'
            }
        else {
            return 'aapt-card-scheduled'
        }
    }


    return (
        <div className={getColor() + ' carrier-appt-card-wrapper my-2 d-flex justify-content-between flex-column'}>
            <div className='d-flex justify-content-between'>
                <p className='aapt-card-text'>
                    <span>{_.upperCase(rowData[0].LoadType) === 'INBOUND' ? AppConstant.poManagement.tableHeader.po: AppConstant.poManagement.tableHeader.so} : {rowData[0].PoNumber || '--'}</span><br />
                    <span className='f-10'>
                        Appt. No.: {rowData[0]?.AppointmentNumber || '--'}
                    </span>
                    <br />
                    <span className='f-10'>
                        {moment(rowData[0]?.ApptStartDate) ? moment(rowData[0]?.ApptStartDate).utc().format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat) + " " + moment(rowData[0]?.ApptStartDate).utc().format(AppConstant.commonStrings.hh_mm_A_dateFormat) : '-'}
                        {/* {getFormattedDate(AppConstant.commonStrings.MM_DD_YYYY_dateFormat, rowData?.ApptStartDate) || '--'} */}
                    </span>
                </p>
                <CustomButtonSS
                    isIcon={true}
                    iconClass={'fa-solid fa-angle-right'}
                    title=''
                    className={"carrier-appt-card-btn"}
                    onClick={() => {
                        //revanth added
                        if (rowData && rowData.length > 0) {
                           // Fix for SPRO-103: Optimize navigation to BookAppointmentScreen to ensure immediate data loading. Additionally, trigger the search API upon navigation to fetch the most recent data.
                            const temp = {searchAPIinitiated: true, ...rowData[0]}
                            dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO, payload: [{...temp}] })
                            dispatch({ type: sagaActions.INTIATE_SS_SEARCH_PO, payload: { PoNumber: rowData[0]?.PoNumber, ReceivingZipCode: rowData[0]?.ReceivingZipCode, UserType: userType, ID: userType === 'CARRIER' ? userAccountDetails?.IDCarrier : rowData[0]?.IDWarehouse } })
                            // if (location?.pathname?.includes('myappointment')) {
                            navigate('/bookappointments', { state: { type: 'rescheduling' } });
                        }
                        // }
                    }}
                />
            </div>
            <div className='d-flex justify-content-end'>
                <p className='f-10 fw-bold'>{rowData[0] && rowData[0].ApptScheStatus.toUpperCase()}</p>
            </div>
        </div>
    )
}

export default CarrierApptCardSS